






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { sendSms, verifyPhone } from '@/apps/open/services/user'
import { USER_CENTER_URL } from '@/apps/open/constants'
import Button from '@/apps/open/components/Button'

declare const window: any
declare const smartCaptcha: any

@Component({
  componentName: 'VerifyPhoneDialogBody',
  data: () => ({
    USER_CENTER_URL
  }),
  components: {
    Button
  }
})
export default class VerifyPhoneDialogBody extends Vue {
  @Prop()
  phone!: string

  @Prop()
  action!: string

  @Prop({
    default: '确定'
  })
  okText!: string

  @Prop()
  onCancel!: Function

  @Prop()
  verifySuccess!: Function

  captchaSuccess = false
  verifyCode = ''
  sendButtonText = '发送验证码'
  sendButtonDisable = false
  time = 60
  timer: any

  submitting = false

  get disabledSubmit () {
    return this.verifyCode.length < 6 || this.submitting
  }

  get tip () {
    return this.captchaSuccess ? `请输入${this.phone}收到的验证码` : '请先完成安全验证'
  }

  destroyed () {
    clearInterval(this.timer)
    window.CaptchaSuccess = null
  }

  timerFun () {
    if (this.time > 0) {
      this.sendButtonText = `重新发送(${this.time})`
      this.time--
    } else {
      clearInterval(this.timer)
      window.resetSmartCaptcha()
      this.time = 60
      this.sendButtonText = '重新发送'
      this.sendButtonDisable = false
    }
  }

  sendVerifyCode () {
    if (!window.CaptchaSuccess) {
      this.$message.warning('请点击智能验证按钮')
      return
    }
    let params: any = {
      action: this.action,
      aliyun_session: window.CaptchaSuccess.sessionId,
      aliyun_scene: window.NVC_Opt.scene,
      aliyun_token: window.CaptchaSuccess.token,
      aliyun_sig: window.CaptchaSuccess.sig,
      aliyun_appkey: window.NVC_Opt.appkey
    }
    sendSms(params)
      .then(() => {
        this.$message.info('验证码已发送')
        this.sendButtonDisable = true
        this.timer = setInterval(this.timerFun, 1000)
      }).catch((error) => {
        if (RegExp('SMSLimitReached').test(error.message)) {
          this.$message.error('验证码发送次数已超过限制，请明天再试')
        } else if (error.message === 'frequency limitation in 60s') {
          this.$message.error('验证码获取太频繁，请稍后重试')
        } else {
          this.$message.error(error.message)
        }
      })
  }

  submit () {
    let params = {
      captcha: this.verifyCode,
      action: this.action
    }
    this.submitting = true
    verifyPhone(params)
      .then((res) => {
        this.verifySuccess(res.data.open_ssid)
      }).catch((error) => {
        switch (error.message) {
          case 'invalid verify code':
            this.$message.error('验证码不正确，请重新输入')
            break
          case 'verify code not exists.':
            this.$message.error('验证码已失效，请重新获取')
            break
          default:
            this.$message.error(error.message)
            break
        }
      }).finally(() => {
        this.submitting = false
      })
  }

  mounted () {
    if (this.phone) {
      this.loadCaptcha()
    }
  }

  loadCaptcha () {
    const _this = this
    var ic = new smartCaptcha({
      renderTo: '#captcha',
      width: '100%',
      success: function (data: any) {
        _this.captchaSuccess = true
        window.CaptchaSuccess = {
          token: window.NVC_Opt.token,
          sessionId: data.sessionId,
          sig: data.sig
        }
      }
    })
    window.resetSmartCaptcha = function () {
      _this.captchaSuccess = false
      _this.verifyCode = ''
      window.CaptchaSuccess = null
      ic.reset()
    }
    ic.init()
  }

  changeVerifyCode () {
    this.verifyCode = this.verifyCode.replace(/\D/g, '')
  }
}
